module.exports = __webpack_public_path__ + "static/media/logo_caa.1750568b.jpg";